import PropTypes from 'prop-types';
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, Form, FormFeedback, Label, Input, CardTitle, CardSubtitle, Spinner } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Redux
import { connect, useDispatch } from "react-redux";

// import { withRouter, Link } from "react-router-dom"
import { Link } from 'react-router-dom';
import withRouter from 'components/Common/withRouter';

// action
import { userForgetPassword } from "../../store/actions";

// import images
import logoSm from "../../assets/images/logo-sm.png";
import bgImage from "../../assets/images/bgImage1.jpg"
import TrueFocus from 'pages/Ui/React-blits/TrueFocus';
import { useForm } from 'react-hook-form';
import useForgotPassReq from './useForgotPassReq';

const ForgetPasswordPage = props => {
  const dispatch = useDispatch();

  const{register,handleSubmit,formState:{errors}}=useForm({
    defaultValues:{
      email:""
    },
    criteriaMode:"all",
    mode:"onChange"
  })

  // hook to make request for password reset
  const{isPending,isSuccess,forgotPassword,data} = useForgotPassReq();

  const onSubmit =(data)=>{
    console.log("forgot email triggerred",data)

    const payload = {
      "email_id":data.email
    }

    forgotPassword(payload)
  }

  document.title = "Title Apprasiser | Reset Password";
  return (
    <React.Fragment>
      <div className='account-pages'>
  <div
    className='accountbg'
    style={{
      background: `url(${bgImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Card
      style={{
        height: "400px",
        width: "400px",
        display: "flex",
        flexDirection: "column",
        borderRadius: "15px",
        padding: "20px",
        borderColor: "white",
        borderWidth: "1.5px",
        backgroundColor: "white",
        boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
        backdropFilter:"blur(10px)",
        opacity:"1"
      }}
    >
      {/* Heading */}
      <Row>
        <Col
          style={{
            display: "flex",
            flexDirection:"column",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h2 style={{color:"#00ADF0"}}>Forgot Password?</h2>
          <h6 style={{fontSize:"13px"}}>Enter the Registered Email Address To Reset Your Password</h6>
        </Col>
      </Row>

      {/* Form */}
      <Row>
        <Col>
          <form className="p-2" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control border-primary-subtle"
                id="email"
                name="email"
                placeholder="Email here....."
                // required
                {...register("email",{required:"Email required",
                  minLength:{value:6, message:"Email must have atleast 6 characters"},
                  pattern:{value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message:"Invalid email format"}
                })}
              />
              {errors.email && <span className="text-danger">{errors.email.message}</span>}
              {data && <span className="text-success">{data.message}</span>}
            </div>
            <div className='mb-3'>
              <button type="submit" className="btn w-100 mt-2" style={{backgroundColor:"#00ADF0", color:"white"}}
                disabled={isPending}
              >
                {isPending ? <Spinner size="sm"/> : "Reset Password"}
            </button>
            </div>

            <div className="text-center mt-1 pt-2 ">
              © {new Date().getFullYear()} TrueFocus Automation. All rights reserved.
            </div>
          </form>
        </Col>
      </Row>
    </Card>
  </div>
</div>

    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  forgetError: PropTypes.any,
  forgetSuccessMsg: PropTypes.any,
  history: PropTypes.object,
  userForgetPassword: PropTypes.func
};

const mapStatetoProps = state => {
  const { forgetError, forgetSuccessMsg } = state.ForgetPassword;
  return { forgetError, forgetSuccessMsg };
};

export default withRouter(
  connect(mapStatetoProps, { userForgetPassword })(ForgetPasswordPage)
);